import { Policy } from '@models/business/Policy'
import {
  createPolicy,
  deletePolicy,
  updatePolicy,
} from '@store/business/PolicyReducer'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

export const PolicyForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const { error } = useAppSelector((state) => state.policy)
  const dispatch = useAppDispatch()

  const transformValuesToShifts = (values: any): Policy => ({
    ...values,
    policyShifts: Object.values(values.policyShifts).filter(
      (e: any) => e.enabled
    ),
  })

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        create: Create,
        update: Update,
        delete: Delete,
      }}
      handlers={{
        create: async (values) =>
          dispatch(createPolicy(transformValuesToShifts(values))).then(() => {
            return true
          }),
        update: async (values) =>
          dispatch(updatePolicy(transformValuesToShifts(values))).then(() => {
            return true
          }),
        delete: async (values) =>
          dispatch(deletePolicy(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

PolicyForm.displayName = 'PolicyForm'

export default PolicyForm
